export default class companyManager {
    constructor() {
        this.openBtn = document.getElementById('p-support-openBtn');
        this.contents = document.getElementById('p-support-contents');

        this.$rootLoad = document.getElementById("l-root-load");
    }

    init() {
        this.openBtn.addEventListener('click',()=>{
            if(this.contents.classList.contains('is-open')){
                this.close();
            }else{
                this.open();
            }
        });
    }

    open(){
        TweenMax.to(this.contents,0.5,{
            display: 'block',
            opacity: 1,
            ease: Power1.easeOut,
            className: "+=is-open"
        });
        this.openBtn.classList.add("is-open");
    }

    close(){
        TweenMax.to(this.contents,0.5,{
            display: 'none',
            opacity: 0,
            ease: Power1.easeIn,
            className: "-=is-open"
        });
        this.openBtn.classList.remove("is-open");
    }

    resize(){
        document.body.style.height = this.$rootLoad.clientHeight + 'px';
    }
}